import { css } from 'styled-system/css';
import { FounderSignature } from './FounderSignature';
import { letterText } from './letterText';

export function FounderSignoff() {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        marginTop: '4',
      })}
    >
      <p className={css(letterText)}>Thank you,</p>
      <FounderSignature />
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '4',
        })}
      >
        <p
          className={css(letterText, {
            color: 'text.primary',
            fontWeight: 'semibold',
          })}
        >
          Andre
        </p>
        <a
          href="https://x.com/andrestaltz"
          aria-label="Andre Staltz on X"
          className={css({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: '0',
            width: '11',
            height: '11',
            margin: '-3',
            color: 'text.muted',
            transition: 'color 200ms {easings.out}',
            _hover: { color: 'text.primary' },
            _focusVisible: {
              outline: '2px solid token(colors.border.focus)',
              outlineOffset: '-2px',
            },
          })}
        >
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            className={css({ width: '5', height: '5', display: 'block' })}
          >
            <path
              fill="currentColor"
              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.725-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}
